import AddEventToSeries from "connection/series/add-event-to-series";
import CreateSeries from "connection/series/create-series";
import DeleteEventFromSeries from "connection/series/delete-event-from-series";
import LoadSeriesFullByEventUuid from "connection/series/load-series-full-by-event-uuid";
import LoadSeriesFull from "connection/series/load-series-full-by-series-uuid";
import LoadSeriesListForChannel from "connection/series/load-series-list-for-channel";
import SetSeriesEvents from "connection/series/set-series-events";
import type { ICreateSeries, ISeriesAssociation, ISeriesPrototype, ISeriesWithEvents, SeriesEvent } from "types/series.types";
import { DispatchedAction, DispatchedAsyncAction } from "types/actions";
import type { SelectedBrandliveEvent } from "@/types/working-model";

export const t_loadSeriesListForChannel = "t_loadSeriesListForChannel";
type LoadSeriesListForChannelAction = DispatchedAsyncAction<typeof t_loadSeriesListForChannel, {
	series: ISeriesPrototype[];
	total: number;
}>;
export function loadSeriesListForChannel(params: {
	channel: number;
	page?: number;
	limit?: number;
	withEvents?: boolean;
	search?: string;
}): LoadSeriesListForChannelAction {
	return {
		type: t_loadSeriesListForChannel,
		promise: LoadSeriesListForChannel(params)
	};
}

export const t_loadSeriesFull = "t_loadSeriesFull";
type LoadSeriesFullAction = DispatchedAsyncAction<typeof t_loadSeriesFull, ISeriesWithEvents>;
export function loadSeriesFull(params: { channel: number; seriesUuid: string }): LoadSeriesFullAction {
	return {
		type: t_loadSeriesFull,
		promise: LoadSeriesFull(params)
	};
}

export const t_loadCurrentSeriesForProject = "t_loadCurrentSeriesForProject";
type loadCurrentSeriesForProjectAction = DispatchedAsyncAction<typeof t_loadCurrentSeriesForProject, ISeriesWithEvents>;
export function loadCurrentSeriesForProject(params: { channel: number; eventUuid: string }): loadCurrentSeriesForProjectAction {
	return {
		type: t_loadCurrentSeriesForProject,
		promise: LoadSeriesFullByEventUuid(params)
	};
}

export const t_createSeries = "t_createSeries";
type createSeriesAction = DispatchedAsyncAction<typeof t_createSeries, ISeriesPrototype>;
export function createSeries(params: ICreateSeries): createSeriesAction {
	return {
		type: t_createSeries,
		promise: CreateSeries(params)
	};
}

export const t_addEventToSeries = "t_addEventToSeries";
type addEventToSeriesAction = DispatchedAsyncAction<typeof t_addEventToSeries, ISeriesAssociation, SelectedBrandliveEvent, SelectedBrandliveEvent>;
export function addEventToSeries(params: {
	channel: number;
	seriesUuid: string;
	project: SelectedBrandliveEvent;
}): addEventToSeriesAction {
	return {
		type: t_addEventToSeries,
		promise: AddEventToSeries({ channel: params.channel, seriesUuid: params.seriesUuid, eventUuid: params.project.uuid }),
		meta: params.project
	};
}

export const t_setSeriesEvents = "t_setSeriesEvents";
type setSeriesEventsActionInput = {
	channel: number;
	seriesUuid: string;
	eventUuids: string[];
	eventData?: SeriesEvent[];
}
type setSeriesEventsAction = DispatchedAsyncAction<typeof t_setSeriesEvents, ISeriesAssociation, setSeriesEventsActionInput, setSeriesEventsActionInput>;
export function setSeriesEvents(params: setSeriesEventsActionInput): setSeriesEventsAction {
	return {
		type: t_setSeriesEvents,
		promise: SetSeriesEvents(params),
		meta: params
	};
}

export const t_deleteEventFromSeries = "t_deleteEventFromSeries";
type deleteEventFromSeriesInput = {
	channel: number;
	seriesUuid: string;
	eventUuid: string;
};
type deleteEventFromSeriesAction = DispatchedAsyncAction<typeof t_deleteEventFromSeries, void, deleteEventFromSeriesInput, deleteEventFromSeriesInput>;
export function deleteEventFromSeries(params: deleteEventFromSeriesInput): deleteEventFromSeriesAction {
	return {
		type: t_deleteEventFromSeries,
		promise: DeleteEventFromSeries(params),
		meta: params
	};
}

export const t_clearCurrentSeries = "t_clearCurrentSeries";
type clearCurrentSeriesAction = DispatchedAction<typeof t_clearCurrentSeries, void>;
export function clearCurrentSeries(): clearCurrentSeriesAction {
	return {
		type: t_clearCurrentSeries,
		payload: undefined
	};
}

export const t_clearSeriesList = "t_clearSeriesList";
type clearSeriesListAction = DispatchedAction<typeof t_clearSeriesList, void>;
export function clearSeriesList(): clearSeriesListAction {
	return {
		type: t_clearSeriesList,
		payload: undefined
	};
}

export const t_appendSeriesSync = "t_appendSeriesSync";
type appendSeriesSyncAction = DispatchedAction<typeof t_appendSeriesSync, ISeriesPrototype>;
export function appendSeriesSync(payload: ISeriesPrototype): appendSeriesSyncAction {
	return {
		type: t_appendSeriesSync,
		payload: payload
	};
}

export const t_setCurrentSeriesSync = "t_setCurrentSeriesSync";
type setCurrentSeriesSyncAction = DispatchedAction<typeof t_setCurrentSeriesSync, ISeriesWithEvents>;
export function setCurrentSeriesSync(payload: ISeriesWithEvents): setCurrentSeriesSyncAction {
	return {
		type: t_setCurrentSeriesSync,
		payload: payload
	};
}

export type SeriesActions = LoadSeriesListForChannelAction |
	LoadSeriesFullAction |
	loadCurrentSeriesForProjectAction |
	createSeriesAction |
	addEventToSeriesAction |
	setSeriesEventsAction |
	deleteEventFromSeriesAction |
	clearCurrentSeriesAction |
	clearSeriesListAction |
	appendSeriesSyncAction |
	setCurrentSeriesSyncAction;